import { createRequest, titanApi } from "./titanApi";

const extendedApi = titanApi
  .enhanceEndpoints({ addTagTypes: ["profile", "preferences", "allUsers"] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getProfile: builder.query({
        query: () => ({
          ...createRequest(`/api/users/account/profile`),
          method: "GET",
        }),
        providesTags: ["profile"],
      }),

      getProfileLogo: builder.query({
        query: () => ({
          ...createRequest(`/api/users/account/preferences`),
          method: "GET",
        }),
        providesTags: ["preferences"],
      }),

      updateProfile: builder.mutation({
        query: (data) => ({
          ...createRequest(`/api/users/account/profile`),
          method: "PUT",
          body: { ...data },
        }),
        invalidatesTags: ["profile", "allUsers"],
      }),

      updatePassword: builder.mutation({
        query: (data) => ({
          ...createRequest(`/api/users/account/security`),
          method: "PUT",
          body: { ...data },
          responseHandler: (response) => response.text(),
        }),
      }),

      updateProfileLogo: builder.mutation({
        query: (data) => ({
          ...createRequest(`/api/users/account/preferences`),
          method: "PUT",
          body: { ...data },
          responseHandler: (response) => response.text(),
        }),
        invalidatesTags: ["preferences"],
      }),
    }),

    // https://redux-toolkit.js.org/rtk-query/usage/code-splitting
    overrideExisting: false,
  });

export const {
  useGetProfileQuery,
  useGetProfileLogoQuery,
  useUpdateProfileMutation,
  useUpdatePasswordMutation,
  useUpdateProfileLogoMutation,
} = extendedApi;
